import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import TopHeader from "../Dashoboard/TopHeader";
import AddIcon from "@mui/icons-material/Add";
import { editIcon, viewIcon } from "../../assets/img";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { saveLoader } from "../../redux/slice/loaderNoti";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import moment from "moment/moment";
import {
  useLazyReceptionistListQuery,
  useLazyReceptionistStatusQuery,
} from "../../redux/api/api";

const ReceptionistList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [list, setList] = useState([]);
  const [overAllCount, setOverALlCount] = useState(1);
  const [pagination, setPagonation] = useState({});
  const [search, setSearch] = useState("");
  const [row, setRow] = useState(10);
  const [filter, setFilter] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [btn, setBtn] = useState(false);

  // RTK QUERY
  const [receptionistList] = useLazyReceptionistListQuery();
  const [receptionistStatus] = useLazyReceptionistStatusQuery();

  const getOwnerList = (
    search_value,
    row_value,
    filter_value,
    from_date,
    to_date
  ) => {
    let params = `?page=${page}`;

    if (search_value) {
      params += `&search=${search_value}`;
    }

    if (row_value) {
      params += `&row=${row_value}`;
    }

    if (filter_value) {
      params += `&filter=${filter_value}`;
    }

    if (from_date) {
      params += `&from_date=${moment(from_date).format("YYYY-MM-DD")}`;
    }

    if (to_date) {
      params += `&to_date=${moment(to_date).format("YYYY-MM-DD")}`;
    }

    setSearch(search_value);
    setRow(row_value);
    setFilter(filter_value);
    setToDate(to_date);
    setFromDate(from_date);
    dispatch(saveLoader(true));
    receptionistList(params)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setList(res?.receptionists);
        setOverALlCount(
          Math.ceil(res?.pagination?.total / res?.pagination?.per_page)
        );
        setPagonation(res?.pagination);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  useEffect(() => {
    getOwnerList(search, row, filter, fromDate, toDate);
  }, [page]);

  const handlePageChange = (selectedObject) => {
    setPage(selectedObject.selected + 1);
  };

  const statusChange = (id) => {
    dispatch(saveLoader(true));
    setBtn(true);
    receptionistStatus(id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setBtn(false);
        if (res?.status == "success") {
          Swal.fire({
            text: res?.message,
            icon: "success",
          });
          getOwnerList(search, row, filter, fromDate, toDate);
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        setBtn(false);
        console.log("err");
      });
  };

  return (
    <div className="dashRightView home_section">
      <TopHeader type={"receptionist-list"} />
      <div className="block block-rounded ">
        <div className="block-content">
          <Row>
            <Col md={6}>
              <label className="table-labels f1">
                Total Count : {pagination?.total}
              </label>
            </Col>
            <Col sm={6} md={6}>
              <div className="d-flex ac-je block-header add-btn">
                <button
                  className="f1 d-flex"
                  onClick={() => navigate("/receptionist")}
                >
                  <AddIcon />
                  Add Receptionist
                </button>
              </div>
            </Col>
          </Row>
          <div className="d-flex ac-jb gap-2">
            <div className="col-md-2 mb-2 p-0">
              <select
                className="form-control custom-select"
                onChange={(e) =>
                  getOwnerList(search, e.target.value, filter, fromDate, toDate)
                }
                value={row}
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </div>
            <div className="col-md-2 mb-2 p-0">
              <select
                className="form-control custom-select"
                onChange={(e) =>
                  getOwnerList(search, row, e.target.value, fromDate, toDate)
                }
                value={filter}
              >
                <option value="">Filter</option>
                <option value="lh">Low to High</option>
                <option value="hl">High to Low</option>
              </select>
            </div>
            <div className="col-md-2 mb-2 p-0">
              <DatePicker
                selected={fromDate}
                onChange={(date) => {
                  getOwnerList(search, row, filter, date, toDate);
                }}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                dateFormat="yyyy-MM-dd"
                todayButton="Today"
                className="form-control custom-select"
                placeholderText="YYYY-MM-DD"
              />
            </div>
            <div className="col-md-2 mb-2 p-0">
              <DatePicker
                selected={toDate}
                onChange={(date) =>
                  getOwnerList(search, row, filter, fromDate, date)
                }
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                dateFormat="yyyy-MM-dd"
                todayButton="Today"
                className="form-control custom-select"
                placeholderText="YYYY-MM-DD"
              />
            </div>
            <div className="col-md-3 mb-2 p-0">
              <input
                className="form-control bg-white"
                placeholder="Eg: Name, Mobile"
                onChange={(e) =>
                  getOwnerList(e.target.value, row, filter, fromDate, toDate)
                }
                value={search}
              />
            </div>
          </div>
          <div className="table-custom-design overflow-scroll">
            <table>
              <thead>
                <tr className="text-capitalize text-nowrap">
                  <th>S.NO</th>
                  <th>Receptionist Id</th>
                  <th>Registered</th>
                  <th>Property Id</th>
                  <th>Receptionist Name</th>
                  <th>Owner Name</th>
                  <th>Mobile Number</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {list?.map((item, ind) => {
                  return (
                    <tr key={ind}>
                      <td>{(pagination?.current_page - 1) * row + ind + 1}</td>
                      <td>{item?.receptionist_id}</td>
                      <td>
                        {item?.crm_date
                          ? moment(item?.crm_date).format("DD-MM-YYYY hh:mm a")
                          : ""}
                      </td>
                      <td>
                        {item?.property?.name
                          ? item?.property?.property_id
                          : "-"}
                      </td>
                      <td>{item?.name ? item?.name : "-"}</td>
                      <td>{item?.owner?.name ? item?.owner?.name : "-"}</td>
                      <td>{item?.mobile ? item?.mobile : "-"}</td>
                      <td>
                        {" "}
                        <button
                          className={`${
                            item?.status == 1 ? "btn-success" : "btn-danger"
                          } px-2 py-1 rounded-1 border-0 text-white`}
                          onClick={() => statusChange(item?.id)}
                          disabled={btn}
                        >
                          {item?.status == 1 ? "Active" : "Deactive"}
                        </button>
                      </td>
                      <td>
                        <div className="d-flex ac-jc gap-2">
                          <button
                            className="cust-btn"
                            onClick={() => {
                              navigate("/receptionist-view", {
                                state: {
                                  type: "view",
                                  data: item,
                                },
                              });
                            }}
                          >
                            <img src={viewIcon} className="edit-btn" />
                          </button>
                          <button
                            className="cust-btn"
                            onClick={() =>
                              navigate("/receptionist", {
                                state: { type: "edit", data: item },
                              })
                            }
                          >
                            <img src={editIcon} className="edit-btn" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="page-inner-cont py-2 d-flex justify-content-end">
            <ReactPaginate
              nextLabel="››"
              onPageChange={handlePageChange}
              pageRangeDisplayed={2}
              marginPagesDisplayed={2}
              pageCount={overAllCount}
              previousLabel="‹‹"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination"
              activeClassName="active"
              renderOnZeroPageCount={null}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default ReceptionistList;
